import React from 'react';

const FrontPageRunToGoal = ({ isActiveWomensMode }) => {
    return (
        <>
            {/* FONDO (Reutilizamos la clase que usas en la portada) */}
            <div className='FrontPage--Riddle__Screen__Background'>
                {/* {isActiveWomensMode ? (
                    // <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                    <img src='/img/games/runtogoal/carrera-atleti/background-frontpage.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                ) : (
                    // <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                    <img src='/img/games/runtogoal/carrera-atleti/background-frontpage.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                )} */}

                <img src='/img/games/runtogoal/redbull/background-frontpage.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
            </div>

            {/* <div className='SelfieFan__Screen__QR__Background'>
                <video 
                    src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    className='SelfieFan__Screen__QR__Background__Video' 
                    autoPlay loop muted playsInline 
                />
            </div> */}

            <div className="goal-intro">
                {/* Ocultamos la cancha y ponemos un fondo oscuro para resaltar el logo */}
                <div className="goal-intro__logo-container">
                    {/* Tiro a gol */}
                    {/* <div className='d-flex'>
                        <img src="/img/page/xolos-five.png" className="LogoADSLxZtudia" alt="Logo" style={{ maxWidth: '500px', width: '500px' }} />
                    </div>
                    <p className="goal-intro__text text-uppercase fw-bold">Presentan</p>
                    */}
                    <p className="goal-intro__text text-uppercase fw-bold" style={{ marginTop: '80px', textShadow: '-3px 0 red, 0 3px red, 3px 0 red, 0 -3px red' }}>Presentan</p>
                    <p className="goal-intro__title fw-bold" style={{ color: '#fff', textShadow: '-6px 0 red, 0 6px red, 6px 0 red, 0 -6px red', fontSize: '9.4em' }}>Red Bull Soapbox</p> {/* Tiro a gol - Carrera Atleti */}
                </div>

                {/* El balón que cae del cielo y rebota */}
                {/* <img src="/img/games/runtogoal/balon-grande.png" className="goal-intro__ball" alt="Balón" /> */}
                {/* <img src="/img/games/runtogoal/carrera-atleti/lucho.png" className="goal-intro__ball" alt="Balón" /> */}
                <img src="/img/games/runtogoal/redbull/xolo-rojo.png" className="goal-intro__ball" alt="Jugador" style={{ width: '500px' }} />

                <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)', fontSize: '30px', color: '#000' }}>Hecho con ♥ por Interaktia | 2026</p>
            </div>
        </>
    );
};

export { FrontPageRunToGoal };